import { LogoCloudCarousel } from "../../../../modules/content/components/LogoCloudCarousel/LogoCloudCarousel";
import { LogoCloudGrid } from "../../../../modules/content/components/LogoCloudGrid/LogoCloudGrid";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ILogoCloudBlockProps } from "./LogoCloudBlock.props";

export const LogoCloudBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
  variant,
}: ILogoCloudBlockProps) => {
  if (!items?.length) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "carousel" ? (
          <LogoCloudCarousel items={items} />
        ) : (
          <LogoCloudGrid items={items} />
        )}
      </div>
    </DaylightSection>
  );
};

LogoCloudBlock.displayName = "Block::LogoCloudBlock";
